export const formatRemainderNumber = (inputNumber: number): string => {
  const number = inputNumber - 3;

  // If below 1099, return the number
  if (number <= 1099) {
    return `+${number}`;
  } else if (number > 1099 && number <= 999900) {
    // Round down to the nearest hundred, then divide by 1000
    const roundedDown = Math.floor(number / 100) * 100;
    const dividedNumber = roundedDown / 1000;

    if (dividedNumber % 1 === 0) {
      // This is so we don't end up with '.0k'
      return `+${dividedNumber}k`;
    } else {
      // If it's not a whole number keep one decimal place
      return `+${dividedNumber.toFixed(1)}k`;
    }
  }
  // If the number is above 999900, cap it at '+999.9k'
  else {
    return '+999.9k';
  }
};

export const formatSnapshotValues = (inputNumber: number): string => {
  if (inputNumber <= 1099) {
    return `${inputNumber}`;
  } else if (inputNumber > 1099 && inputNumber <= 999900) {
    const roundedDown = Math.floor(inputNumber / 100) * 100;
    const dividedNumber = roundedDown / 1000;

    if (dividedNumber % 1 === 0) {
      return `${dividedNumber}k`;
    } else {
      return `${dividedNumber.toFixed(1)}k`;
    }
  } else {
    return '999.9k';
  }
};
